import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useId, useMemo } from "react";
import { useBoolean } from "usehooks-ts";
import Icon from "../../../../../base/icons/icon/index.js";
import FlatpickrCalendar from "../../../../lib/flatpickr-calendar/index.js";
import { KEY_CODE } from "../../../../../../types/key-code.js";
import CustomFlatpickrCalendarInput from "../../calendar-input/index.js";
import { buildDisableDates, buildEnableDates } from "../../helpers/index.js";
import * as SS from "../../styled.js";
const CalendarDesktop = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { label , disabled =false , value =[
        new Date()
    ] , onChange , onBlur , error , hasError , locale , mode ='single' , minDate ='today' , showMonths =1 , enableTime =false , monthSelectorType ='static' , dateFormat , minuteIncrement =30 , noCalendar =false , disableMobile =true , time24h =true , minTime ='00:00' , maxTime ='23:59' , className ='' , events , options , releaseDays , icon ='calendar'  } = props;
    const { value: internalFocused , setTrue: onOpen , setFalse: onClose  } = useBoolean();
    const uniqueId = useId();
    const inputId = useMemo(()=>`${uniqueId}-input-calendar-${label}`, [
        label,
        uniqueId
    ]);
    const handleCloseCalendar = useCallback(()=>{
        onClose();
        onBlur?.();
    }, [
        onBlur,
        onClose
    ]);
    // Used to disable prev days if return operative is enabled
    const finalDisableDates = buildDisableDates(props);
    const finalEnableDates = buildEnableDates(props, finalDisableDates);
    const calendarOptions = useMemo(()=>({
            altInputClass: '',
            wrap: false,
            defaultDate: value,
            defaultMinute: 0,
            time_24hr: time24h,
            minDate,
            // maxDate,
            mode,
            showMonths,
            dateFormat: dateFormat ?? (enableTime ? 'D, j M Y H:i' : 'D, j M Y'),
            disableMobile,
            monthSelectorType,
            noCalendar,
            enableTime,
            minuteIncrement,
            minTime,
            maxTime,
            ...options
        }), [
        dateFormat,
        disableMobile,
        enableTime,
        // maxDate,
        minDate,
        minTime,
        maxTime,
        minuteIncrement,
        mode,
        monthSelectorType,
        noCalendar,
        options,
        showMonths,
        time24h,
        value
    ]);
    const renderInput = useCallback((props, ref)=>/*#__PURE__*/ _jsxs(SS.CalendarWrapper, {
            "data-testid": "Calendar",
            children: [
                /*#__PURE__*/ _jsx(SS.CalendarInputIcon, {
                    children: /*#__PURE__*/ _jsx(Icon, {
                        className: `nico-${icon}`
                    })
                }),
                /*#__PURE__*/ _jsx(SS.CalendarLabel, {
                    htmlFor: inputId,
                    children: label
                }),
                /*#__PURE__*/ _jsx(CustomFlatpickrCalendarInput, {
                    id: inputId,
                    disabled: disabled,
                    value: props.value,
                    defaultValue: props.defaultValue,
                    inputRef: ref,
                    error: error,
                    hasError: hasError,
                    isFocused: internalFocused
                })
            ]
        }), [
        disabled,
        error,
        hasError,
        inputId,
        internalFocused,
        label,
        icon
    ]);
    const finalValue = useMemo(()=>mode === 'single' ? [
            value[0]
        ] : value, [
        value,
        mode
    ]);
    const pressHandlerCalendar = useCallback((event)=>{
        switch(event.key){
            case KEY_CODE.ENTER:
                event.preventDefault();
                break;
            case KEY_CODE.ESC:
                break;
            default:
                break;
        }
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        onKeyDown: (e)=>pressHandlerCalendar(e),
        children: /*#__PURE__*/ _jsx(FlatpickrCalendar, {
            locale: locale,
            render: renderInput,
            value: finalValue,
            options: calendarOptions,
            onChange: onChange,
            className: className,
            ref: ref,
            events: events,
            enableDates: finalEnableDates,
            onOpen: onOpen,
            onClose: handleCloseCalendar,
            disabled: disabled,
            releaseDays: releaseDays
        })
    });
});
CalendarDesktop.displayName = 'CalendarDesktop';
export default CalendarDesktop;

//# sourceMappingURL=index.js.map